export const PAYMENT_REVIEW_MESSAGE = '결제 결과 확인이 필요합니다. 중복 결제를 방지하기 위해 추가 결제가 제한되었습니다. 마이페이지에서 예약 상태를 확인하고 고객센터로 문의해 주세요.';

export function shouldBlockPaymentRetry(error, paymentSucceeded = false) {
  const body = error?.response?.data;
  if (paymentSucceeded || body?.payment_retry_blocked === true) return true;
  if (body?.payment_attempted === false || body?.payment_outcome === 'rejected') return false;
  // A lost HTTP response is not proof that the charge failed.
  return !error?.response || Number(error.response.status) >= 500;
}
